import { Badge } from "@/components/ui/badge";
import { AppIcons, IconSizes, getFamiliaIcon } from "@/lib/icons";

interface ItemBadgeProps {
  familia: string;
  faturamentoTipo?: string;
  showIcon?: boolean;
}

export function ItemBadge({ familia, faturamentoTipo, showIcon = true }: ItemBadgeProps) {
  const { icon: FamiliaIcon } = getFamiliaIcon(familia);
  const badgeColor = 'bg-muted text-muted-foreground border-border';
  const FaturamentoIcon = faturamentoTipo === 'VENDA NOVA' ? AppIcons.vendaNova : AppIcons.migracao;

  return (
    <div className="flex items-center gap-2">
      <Badge variant="outline" className={`text-xs flex items-center gap-1.5 ${badgeColor}`}>
        {showIcon && <FamiliaIcon className={IconSizes.xs} />}
        <span className="uppercase">{familia}</span>
      </Badge>
      {faturamentoTipo && (
        <Badge variant="outline" className={`text-xs flex items-center gap-1.5 ${badgeColor}`}>
          <FaturamentoIcon className={IconSizes.xs} />
          <span className="uppercase">{faturamentoTipo}</span>
        </Badge>
      )}
    </div>
  );
}
